export enum ComponentAttributeCategory {
  EDITABLE = 'EDITABLE',
  READ_ONLY = 'READ_ONLY'
}
